/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Listen_On_Go_DescriptionInputs */

const en_features_listen_on_go_description = /** @type {(inputs: Features_Listen_On_Go_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Have a physical book you want to listen to? No problem - just snap a few quick photos to turn it into audio!`)
};

const es_features_listen_on_go_description = /** @type {(inputs: Features_Listen_On_Go_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Tienes un libro físico que quieres escuchar? No hay problema - ¡solo toma unas fotos rápidas para convertirlo en audio!`)
};

/**
* | output |
* | --- |
* | "Have a physical book you want to listen to? No problem - just snap a few quick photos to turn it into audio!" |
*
* @param {Features_Listen_On_Go_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const features_listen_on_go_description = /** @type {((inputs?: Features_Listen_On_Go_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Listen_On_Go_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_features_listen_on_go_description(inputs)
	return en_features_listen_on_go_description(inputs)
});